import { put } from "redux-saga/effects";

import { IChangeCollaboratorRoleAction } from "../types";
import { changeCollaboratorRole } from "./../actionCreators";

export function* changeCollaboratorRoleSaga({ payload: { id, newRole } }: IChangeCollaboratorRoleAction) {
    try {
        yield put(changeCollaboratorRole({ id, newRole }));
    } catch (error) {
        // yield put(Handle Error);
    }
}
